import { BlockType } from '@empathy/survey/base';

export const BlockTypeAllowConditionals: BlockType[] = [BlockType.Group, BlockType.MultiBlock, BlockType.LoopParent];

export const BlockTypeContainers: BlockType[] = [BlockType.MultiBlock, BlockType.LoopParent];
